import { CSSObject } from "@emotion/react"
import styled from "@emotion/styled"
import { faCamera, faCircleQuestion, faKeyboard } from "@fortawesome/pro-solid-svg-icons"
import { L1ReasonableButton } from "../l1/L1Button"
import { FusionColor } from "../../../theme/FusionStyle"

export const L3MedicationReconciliationTableActionsRoot = styled.div(({theme}): CSSObject => ({
	display: 'grid',
	gridTemplateColumns: 'max-content max-content 1fr max-content',
	alignItems: 'center',
	gap: theme.spacing(2),
}))

type L3MedicationReconciliationTableActionsProps = {
	onScannerClick: () => void,
	onManualEntryClick: () => void,
	onHelpClick: () => void,
}

const L3MedicationReconciliationTableActions = ({onScannerClick, onManualEntryClick, onHelpClick}: L3MedicationReconciliationTableActionsProps) => {
	return (
		<L3MedicationReconciliationTableActionsRoot>
			<L1ReasonableButton wide label="Scan Drugs" icon={faCamera} onClick={onScannerClick} />
			<L1ReasonableButton wide label="Manual Entry" icon={faKeyboard} onClick={onManualEntryClick} />
			<div></div>
			<L1ReasonableButton wide color={FusionColor.White} label="Help" icon={faCircleQuestion} onClick={onHelpClick} />
		</L3MedicationReconciliationTableActionsRoot>
	)
}

export default L3MedicationReconciliationTableActions